import '../i18n';

import { createRootRoute, HeadContent, Link, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { Navigation } from '../components/Navigation';

const RootComponent = (): React.ReactNode => (
  <>
    <HeadContent />
    <Navigation />
    <Outlet />
    <LanguageSwitcher />
  </>
);

// oxlint-disable-next-line react/no-multi-comp
const NotFoundComponent = (): React.ReactNode => {
  const { t } = useTranslation('common');

  return (
    <main className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-white px-4 py-16">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div
          className="absolute -top-40 -right-40 size-80 rounded-full opacity-20 blur-3xl"
          style={{ background: '#CBE7F7' }}
        />
        <div
          className="absolute -bottom-40 -left-40 size-80 rounded-full opacity-20 blur-3xl"
          style={{ background: '#CBE7F7' }}
        />
      </div>
      <h1 className="mb-4 text-6xl font-bold" style={{ color: '#1F4D67' }}>
        {/* oxlint-disable-next-line react/jsx-no-literals */}
        404
      </h1>
      <p className="mb-8 text-xl" style={{ color: '#1F4D67' }}>
        {t('pageNotFound')}
      </p>
      <Link to="/" className="font-medium transition-colors duration-200 hover:underline" style={{ color: '#1F4D67' }}>
        {t('goBackHome')}
      </Link>
    </main>
  );
};

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
  head: () => ({
    links: [{ href: '/favicon.png', type: 'image/png', rel: 'icon' }],
    meta: [
      { charSet: 'utf-8' },
      { content: 'width=device-width, initial-scale=1.0', name: 'viewport' },
      { title: 'Liza Health' },
    ],
  }),
});
